import { NgModule } from '@angular/core';
import { BallotStatusPillComponent } from './ballot-status-pill.component';
import { SharedModule } from '../../../../shared/shared.module';

@NgModule({
    declarations: [
        BallotStatusPillComponent
    ],
    exports: [
        BallotStatusPillComponent
    ],
    imports: [
        SharedModule
    ]
})
export class BallotStatusPillModule { }
